import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'
import { Grid, Menu, MenuItem } from '@mui/material'
import type { MouseEvent } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import CustomButton from '@/components/inputs/CustomButton'

type BiddingActionsMenuProps = {
  canMutateBidding: boolean
}

function BiddingActionsMenu({ canMutateBidding }: Readonly<BiddingActionsMenuProps>) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = anchorEl !== null

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleNavigate = (path: string) => {
    handleClose()
    navigate(path)
  }

  return (
    <>
      <CustomButton
        aria-controls={open ? 'bidding-actions-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        color="inheritWhite"
        data-testid="bidding-actions-menu-button"
        endIcon={<KeyboardArrowDownIcon />}
        variant="outlined"
        onClick={handleClick}
      >
        {t('bidding.overview.actions')}
      </CustomButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        id="bidding-actions-menu"
        open={open}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        onClose={handleClose}
      >
        <MenuItem aria-label={t('bidding.exports.title')} onClick={() => handleNavigate('/bidding/exports')}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 'auto' }} sx={{ display: 'flex' }}>
              <GetAppOutlinedIcon />
            </Grid>
            <Grid size={{ xs: 'auto' }}>{t('bidding.exports.title')}</Grid>
          </Grid>
        </MenuItem>
        {canMutateBidding && (
          <MenuItem
            aria-label={t('bidding.overview.import_energy_offers')}
            onClick={() => handleNavigate('/bidding/import-energy-offers')}
          >
            <Grid container spacing={2}>
              <Grid size={{ xs: 'auto' }} sx={{ display: 'flex' }}>
                <UploadFileOutlinedIcon />
              </Grid>
              <Grid size={{ xs: 'auto' }}>{t('bidding.overview.import_energy_offers')}</Grid>
            </Grid>
          </MenuItem>
        )}
        <MenuItem
          aria-label={t('bidding.overview.export_allocated_volumes')}
          onClick={() => handleNavigate('/bidding/dashboard')}
        >
          <Grid container spacing={2}>
            <Grid size={{ xs: 'auto' }} sx={{ display: 'flex' }}>
              <FileDownloadOutlinedIcon />
            </Grid>
            <Grid size={{ xs: 'auto' }}>{t('bidding.overview.export_allocated_volumes')}</Grid>
          </Grid>
        </MenuItem>
      </Menu>
    </>
  )
}

export default BiddingActionsMenu
